import { Loading } from '@lib/components'
import type { ID } from '@octopus-do/octopus-project-core'
import { ArrowDownThin, ImageThin } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import { UploadInput } from './components/UploadInput'
import css from './styles.module.css'
import { useUploadOpenGraph } from './useUploadOpenGraph'

interface Props {
  cnClassName: string
  nodeId: ID
  readOnly: boolean
  hasAccess: boolean
}

export const DropOpenGraph: React.FC<Props> = ({
  cnClassName,
  nodeId,
  readOnly,
  hasAccess,
}) => {
  const {
    dragActive,
    error,
    withParent,
    loading,
    handleDrag,
    handleDrop,
    handleChange,
    handleUseParent,
  } = useUploadOpenGraph(nodeId)

  const hidden = !hasAccess || readOnly
  const showImageThin = (!dragActive && !loading) || hidden
  const showUploadEl = !hidden && !loading
  const showDropArea = dragActive && !hidden && !loading

  const formCls = clsJoin(
    css.drop_open_graph,
    cnClassName,
    showDropArea && css.drag_active,
    hidden && css.show
  )

  return (
    <>
      <form
        className={formCls}
        onDragEnter={handleDrag}
        onSubmit={(e) => e.preventDefault()}
      >
        {showImageThin && (
          <ImageThin className={css.drop_open_graph_empty_icon} />
        )}

        {loading && <Loading type="medium" color="default" />}

        {showUploadEl && (
          <div className={css.drop_open_graph_upload}>
            <UploadInput
              dragActive={dragActive}
              withParent={withParent}
              onChange={handleChange}
              onUseParent={handleUseParent}
            />
          </div>
        )}

        {showDropArea && (
          <div
            className={css.drop_open_graph_area}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
          >
            <ArrowDownThin className={css.drop_open_graph_icon} />
          </div>
        )}
      </form>

      {error && (
        <div className={css.drop_open_graph_error}>
          Unsupported file format. Please upload a PNG or JPEG image, pref
          1200×630px.
        </div>
      )}
    </>
  )
}
